import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, TextField, Typography } from '@mui/material';
import { AppState } from 'store/store';
import { useSelector } from 'react-redux';
import { MainLoader } from 'components/Loader/Loader';
import './PersonDataModal.sass';

interface Props {
  onHide: () => void;
  confirm: (pinfl: string, dateOfBirth: string) => void;
  loading?: boolean;
}

export const PersonDataModal: React.FC<Props> = ({
  onHide,
  confirm,
  loading,
}) => {
  const [pinfl, setPinfl] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.pages.CreateApplicationPage
  );

  const submitForm = (e: React.FormEvent) => {
    e.preventDefault();
    confirm(pinfl, dateOfBirth);
  };

  const changePinfl = (value: string) => {
    const onlyDigits = value.replace(/\D/g, '').slice(0, 14);
    setPinfl(onlyDigits);
  };

  return (
    <div className='person-data-modal'>
      <form
        className='person-data-modal__form'
        onSubmit={submitForm}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='person-data-modal__close' onClick={onHide}>
          <CloseIcon />
        </div>
        <Typography variant='h4' className='person-data-modal__title'>
          {i18n.getData}
        </Typography>
        <TextField
          variant='outlined'
          autoFocus
          value={pinfl}
          onChange={(e) => changePinfl(e.target.value)}
          autoComplete='off'
          label={i18n.pinfl}
          size='small'
        />
        <TextField
          value={dateOfBirth}
          onChange={(e) => setDateOfBirth(e.target.value)}
          label={i18n.dateOfBirth}
          autoComplete='off'
          inputProps={{ maxLength: 255 }}
          variant='outlined'
          size='small'
          type='date'
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant='contained'
          color='success'
          size='medium'
          type='submit'
          className='person-data-modal__form__button'
          disabled={loading || pinfl.length !== 14 || !dateOfBirth.trim()}
        >
          {loading ? <MainLoader /> : i18n.send}
        </Button>
      </form>
    </div>
  );
};
